import { defineStore } from "pinia";
export const useRefundStore = defineStore({
    id: "useRefundStore",
    state: () => ({
        isLoadingRefund: false
    }),
    getters: {},
    actions: {
        async refundRegistration(data: any): Promise<any> {
            if(this.isLoadingRefund) {
                return;    
            }

            this.isLoadingRefund = true;
            try {
                var url = `/api/Participation/Refund`;
                const response = await this.axiosFactory.withoutToken().post(url, data);
                return response.data;
            } catch (error: any) {
                console.log(error.response)
            } finally {
                this.isLoadingRefund = false;
            }
        },
    }
});
